import { render, staticRenderFns } from "./BattleRegisterCrew.vue?vue&type=template&id=4c49c064&scoped=true"
import script from "./BattleRegisterCrew.vue?vue&type=script&lang=js"
export * from "./BattleRegisterCrew.vue?vue&type=script&lang=js"
import style0 from "./BattleRegisterCrew.vue?vue&type=style&index=0&id=4c49c064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49c064",
  null
  
)

export default component.exports